import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LeaveAware } from '@core/guard/deactivate-guard/leave-aware';

@Injectable({
  providedIn: 'root',
})
export class ApplicationLeaveService {
  private translate = inject(TranslateService);

  public handleUnload(event: BeforeUnloadEvent, component?: LeaveAware) {
    if (component?.isOkToLeave() !== true) {
      const message = this.translate.instant('common.LEAVE_APPLICATION_WARNING');
      event.preventDefault();

      // for legacy browsers
      // eslint-disable-next-line @typescript-eslint/no-deprecated
      event.returnValue = message;
    }
  }
}
